import {Component, computed, inject, OnInit} from '@angular/core'
import {ActivatedRoute} from '@angular/router'
import {
  FooterComponent,
  SpbAccessibleLinkDirective
} from '@sparbanken-syd/sparbanken-syd-theme'
import {filter} from 'rxjs'
import version from '../../assets/package.json'
import {environment} from '../../environments/environment'
import {ICalculator} from '../application/types'
import {HeaderComponent} from '../common/header/header.component'
import {HemnetService} from '../services/hemnet.service'
import {InterestService} from '../services/interest.service'
import {CalculationComponent} from './calculation/calculation.component'
import {InputComponent} from './input/input.component'
import {ObjectInfoComponent} from './object-info/object-info.component'

const typeMap: Record<number, string> = {
  0: 'Villa',
  1: 'Fritidshus',
  2: 'Bostadsrätt'
}

@Component({
  selector: 'spb-hemnet',
  templateUrl: './hemnet.component.html',
  styleUrls: ['./hemnet.component.scss'],
  imports: [HeaderComponent, ObjectInfoComponent, InputComponent, CalculationComponent, FooterComponent, SpbAccessibleLinkDirective]
})
export class HemnetComponent implements OnInit {
  public readonly version = version.version

  public readonly utmTags = environment.utmTags

  public calculatorQuery = computed(() => {
    const i = this.hemnetService.hemnetData()

    const calculator: ICalculator = {
      avgift: this.hemnetService.fee(),
      downPayment: this.hemnetService.downPayment(),
      expenses: Math.round(this.hemnetService.runCost() / 12),
      houseType: typeMap[i.type as number] as ICalculator['houseType'],
      interestRate: this.hemnetService.interestRate(),
      loanAmount: this.hemnetService.askingPrice()
    }

    return new URLSearchParams(calculator as any).toString()
  })

  public readonly interestService = inject(InterestService)

  protected readonly calculatorUrl = environment.calculatorUrl

  protected readonly hemnetService = inject(HemnetService)
  protected readonly environment = environment
  private readonly route = inject(ActivatedRoute)

  public ngOnInit(): void {
    this.route.queryParamMap
      .pipe(filter(params => params.has('id')))
      .subscribe(params => {
        this.hemnetService.getHemnetData(params.get('id')!)
      })
  }
}
